import React from "react";
import { ContentSection } from "sprint-common-web";

import { RecordType } from "../../../../common/types/RecordType";
import { useOnPremAssetDetails } from "../common/hooks/useOnPremAssetDetails";
import { OnPremAudioLanguagesSection } from "./audio/OnPremAudioLanguagesSection";
import { OnPremSubtitleLanguagesSection } from "./subtitle/OnPremSubtitleLanguagesSection";
import { OnPremVideoAssetLanguagesSection } from "./video/OnPremVideoLanguagesSection";

export const OnPremLanguagesSection: React.FunctionComponent = () => {
    const { data: assetDetails, isLoading } = useOnPremAssetDetails();

    switch (assetDetails?.type) {
        case RecordType.Audio:
            return <OnPremAudioLanguagesSection isLoading={isLoading} language={assetDetails.soundtrack} />;
        case RecordType.Subtitle:
            return <OnPremSubtitleLanguagesSection isLoading={isLoading} language={assetDetails.subtitle} />;
        case RecordType.Video:
            return <OnPremVideoAssetLanguagesSection isLoading={isLoading} language={assetDetails.subtitle} />;

        default:
            return <ContentSection header="Languages" isLoading={true} />;
    }
};
